import { Button } from "@components/ui/Button";
import { Spinner } from "@components/ui/Spinner";
import React, { FC } from "react";

interface LoadMoreProps {
  fetchNextPage: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  text: string;
}

const LoadMore: FC<LoadMoreProps> = ({
  fetchNextPage,
  isFetchingNextPage,
  hasNextPage,
  text,
}) => {
  if (!hasNextPage) {
    return <React.Fragment />;
  }

  return (
    <div className="flex items-center justify-center">
      {isFetchingNextPage && <Spinner />}
      {!isFetchingNextPage && (
        <Button
          variant="default"
          className="px-10"
          onClick={() => fetchNextPage()}
          disabled={!hasNextPage || isFetchingNextPage}
        >
          {text}
        </Button>
      )}
    </div>
  );
};

export default LoadMore;
